export const SERVICE_GROUPS: Record<string, string[]> = {
  administration_et_gestion: [
    "administration-de-serveur",
    "administration-reseau",
    "assistant-personnel",
    "comptabilite",
    "consultant-en-gestion-d-entreprise",
    "dba-administration-de-base-de-donnee",
    "erp-crm-mise-en-oeuvre",
    "gestion-de-courriels",
    "gestion-de-projet",
    "gestion-de-projet-logiciel",
    "gestion-de-projet-web",
    "plan-d-affaires",
    "recrutement",
    "ressources-humaines",
    "saisie-de-donnees",
    "service-client",
    "service-conseil",
    "services-financiers-et-de-planification",
    "strategie-et-planification",
    "traitement-de-commandes-en-ligne",
    "traitement-des-paiements",
  ],
  design_et_multimedia: [
    "animation-2d",
    "animation-3d",
    "artistes",
    "architecture",
    "conception-graphique",
    "costumes",
    "creation-de-logo",
    "design-d-interface-de-logiciel",
    "design-d-interface-ux-ui",
    "design-d-interieur",
    "design-imprime",
    "design-web",
    "direction-artistique",
    "direction-de-creation",
    "illustration",
    "modelisation-3d-et-cad",
    "presentation-graphique",
    "scenographie-decors",
    "autres-design-et-multimedia",
  ],
  developpement_web_et_logiciel: [
    "applications-mobiles",
    "developpement-de-jeux",
    "developpement-de-logiciel-de-bureau",
    "e-commerce",
    "ergonomie-de-logiciel",
    "ergonomie-web-qa",
    "ingenierie-et-design-technique",
    "intelligence-artificielle",
    "logiciel-plug-ins",
    "programmation-web",
    "recherche-web",
    "scripts-et-utilitaires",
    "technique",
    "autres-developpement-de-logiciels",
    "autres-developpement-web",
    "autres-reseaux-et-systemes-d-information",
    "analyse-statistique",
  ],
  marketing_communication_et_ventes: [
    "gestion-des-medias-sociaux",
    "inbound-marketing-marketing-d-attraction",
    "marketing-par-courriel",
    "marketing-web",
    "pr-relations-publiques",
    "publicite",
    "sem-marketing-par-le-positionnement-payant-dans-les-moteurs-de-recherche",
    "seo-optimisation-organique-pour-les-moteurs-de-recherche",
    "smm-marketing-par-les-medias-sociaux",
    "telemarketing-et-televente",
    "ventes-et-prospection",
    "etudes-de-marche",
    "autres-communication-et-marketing",
    "autres-service-a-la-clientele", // putting customer service related in marketing/sales/comm broadly or creating a separate, but let's stick to this for now or Admin
  ],
  production_audiovisuelle: [
    "camera",
    "coiffure-maquillage",
    "photographie",
    "post-production",
    "production-audio",
    "production-imprime",
    "production-tv",
    "production-video",
    "realisation",
    "regie-tv",
    "regie-production",
    "son",
    "voix-hors-champ",
    "autres-radio-tv-cinema-et-arts-de-la-scene",
  ],
  redaction_et_traduction: [
    "blog-et-redaction-d-articles",
    "contenu-de-site-web",
    "redaction",
    "redaction-creative",
    "redaction-technique",
    "revision-de-textes",
    "traduction",
    "transcription-de-textes",
    "autres-redaction-et-traduction",
  ],
  services_juridiques: ["juridique"],
  services_techniques_et_support: [
    "soutien-technique",
    "soutien-telephonique",
    "voip",
  ],
  autres_services: [
    "transport",
    "autres-services-aux-entreprises",
    "autres-soutien-administratif",
  ],
};
